import React from 'react';
import PropTypes from 'prop-types';
import GenericButton from '../../common/GenericButton';

const HighlightAndFilterItem = ({
  item,
  handleRuleSelection,
  removeSelected,
}) => {
  const onRuleSelection = event => {
    event.preventDefault();
    const selectedElementId = event.currentTarget.id;
    handleRuleSelection(selectedElementId);
  };

  if (!item.isHighlight) {
    return (
      <li
        onClick={onRuleSelection}
        className={item.selected ? 'active-rule' : ''}
        id={item.key}
      >
        <a>
          <span className="label label-red">Remove</span> {item.ButtonOneText}{' '}
          {item.ButtonTwoText} {item.InputValue}
          <GenericButton
            name=""
            btnStyle="position-btn"
            onBtnClick={e => {
              e.stopPropagation();
              removeSelected(item.key);
            }}
          />
        </a>
      </li>
    );
  }
  return (
    <li
      onClick={onRuleSelection}
      className={item.selected ? 'active-rule' : ''}
      id={item.key}
    >
      <a>
        <span className="label">Highlight</span> {item.ButtonOneText}{' '}
        {item.ButtonTwoText} {item.InputValue}
        <GenericButton
          name=""
          btnStyle="position-btn"
          onBtnClick={e => {
            e.stopPropagation();
            removeSelected(item.key);
          }}
        />
      </a>
    </li>
  );
};

HighlightAndFilterItem.propTypes = {
  item: PropTypes.shape({}),
  handleRuleSelection: PropTypes.func,
  removeSelected: PropTypes.func,
};

export default HighlightAndFilterItem;
